export default {
  route: {
    home: '首頁',
    waybill: '運單管理',
    addWaybill: '新增運單',
    editWaybill:'編輯運單',
    modifyWaybill:'修改運單',
    waybillPrinting: '運單打印',
    batchImport: '批量導入',
    routing: '運單查詢',
    address: '地址管理',
    receipt: '收件紀錄',
    system: '系統設置',
    i18n: '国际化',
    generate:'生成運單',
    Balance:'餘額明細',
    charges:'收費明細'
  },
  login: {
    cxcTitle: 'CXC網店寄件系統',
    logIn: '登錄',
    register:'註冊',
    username: '賬號',
    password: '密碼',
    userNameEmpty:'用戶名不能為空',
    userNameRules:'請輸入正確的用戶名',
    passwordRules:'密碼不能少於6位',
    passwordEmpty:'密碼不能為空',
  },
  home: {
    serviceV1: '服務條款',
    agree:'同意',
    disagree: '不同意',
    notice:'公司訊息',
  },
  search:{
    search1:'搜索',
    reset1:'重置'
  },
  charges:{
    date:'查詢日期'
  },
  table:{
    no:'序號',
    createTime:'生成時間',
    waybillSchOrder:'運單編號',
    waybillPlainOrder:'客戶原運單',
    dateReceived:'收件日期',
    addressee:'收件人',
    phone: '聯繫電話',
    toAdress: '收件地址',
    Region:'大區',
    Microzone:'細區',
    weight: '重量',
    settlementWay: '結算方式',
    printStatus:'打印狀態',
    operation: '操作',
    download:'下發',
    modify:'修改',
    print:'列印',
    receiving:'提貨',
    submit:'提交',
    cancel: '取消',
    delete: '刪除',
    confirm: '確認',
    routingTime:'路由時間',
    routingDetails:'路由詳情',
    remarks:'備註',
    customerName:'客戶名稱',
    editor:'編輯',
  },
  waybill: {
    freight:'運費預付/到付',
    waybillManagement:'運單管理',
    waybillSchOrder:'運單編號',
    waybillPlainOrder:'客戶原運單',
    waybillList:'運單清單',
    waybillPrinting:'運單打印',
    RefreshWaybill:'重新整理',
    exportWaybill:'導出運單',
    newWaybill:'新增運單',
    Waybillno:'運單編號',
    batchImport:'批量導入',
    batchCancel:'批量取消',
    templateDownload:'模版下載',
    toAdress: '收件地址',
    phone: '聯繫電話',
    products:'產品',
    schStatus: '運單狀態',
    printStatus:'打印狀態',
    a4Printing:'A4打印',
    thermalPrinting:'熱敏打印',
    time: '生成時間',
    singleTime: '落單時間',
    startDate:'開始日期',
    endDate:'結束日期',
    delete: '刪除',
    confirm: '確定',
    cancel: '重置',
    orderModification:'訂單修改',
    orderNumber:'訂單號',
    orderTime:'訂單時間',
    shippingAddress:'配送地址',
    tel:'聯繫電話',
    distributor:'配送员',
    status:'状态',
    confirm2: '確認',
    PleaseTime:'請輸入時間',
    PleaseAddress:'請輸入地址',
    PleasePhone:'請輸入聯繫方式',
    PleaseName:'請輸入姓名',
    PleaseOrderStatus:'請輸入訂單狀態',
  },
  addWaybill: {
    // 新建運單
    customerInfo:'客戶信息',
    companyName:'公司名稱',
    customerOriginalWaybill:'客戶原運單',
    dateReceived:'收件日期',
    receivingInfo:'收件信息',
    addressee:'收件人',
    commodityInfo:'商品信息',
    commodityContent:'商品內容',
    quantity:'呎吋 (3邊呎碼)',
    unitPrice:'單價',
    totalValue:'總價值',
    totalWeight:'總重量',
    collectionService:'代收服務',
    collectFreight:'代收運費',
    collectPayment:'代收貨款',
    collectTotalFees:'代收總費用',
    remark:'備註',
  },
  routing: {
    routingQuery: '運單查詢',
    routingInfo: '路由信息',
    waybillAccepted:'確認運單',
    pickUp: '已上門取件',
    warehousing: '已入倉',
    onTheWay: '派送途中',
    pickedUpSuccessfully: '已成功派送',
  },
  address: {
    addressManagement: '地址管理',
    receivingCompany:'收件公司',
    addressList:'地址列表',
    addAddress:'新增地址',
    batchDeletion:'批量刪除',
  },
  receipt: {
    pickupConfig: '收件記録',
    status: '狀態',
    receivingList:'收件列表',
    addReceipt:'上門提貨',
    batchDeletion:'批量刪除',
    taskNumber:'任務編號',
    quantityReceived:'收件數量',
    submitDate:'提交日期',
    visitingTime:'上門時間',
    actualQuantity:'實際數量',
    orderModify:'訂單修改',
    totalWeight:'總重量',
    overallDimensions:'呎吋 (3邊呎碼)',
    pleaseQuantity:'請輸入數量',
    pleaseTotalWeight:'請輸入總重量',
    pleaseTotalSize:'請輸入總尺寸',
    pleaseRemarks:'請輸入備註',
  },
  batchImport:{
    batchImportProcess:'批量導入流程',
    downloadTemplate:'下載模版',
    message:'填寫信息',
    uploadFiles:'上載文件',
    editAndModify:'編輯修改',
    confirmImport:'確定提交',
    clickUploadFile:'點擊上載文件',
    importNotice:'導入須知',
    matter1:'1.為確保導入成功率，請根據模版指定格式填寫運單信息',
    matter2:'2.導入成功的運單方可保存至系統，導入失敗的運單可在下方查看并修改，修改完後通過導入成功列表保存至系統。',
    matter3:'3.導入文件僅支持上傳Excel表格，文件大小需小於5M',
    successList:'成功列表',
    failList:'失敗列表',
    tip1:'運單資料導入中，請勿操作......',
    tip2:'運單資料導入完成',
    importSuccess:'導入成功:',
    importFail:'導入失败:',
    // 批量導入文件的顯示
    companyName:'公司名稱',
    waybillNo:'*客戶原運單',
    orderNo:'*客戶運單編號',
    products:'*產品',
    addressee:'*收件人',
    phone:'*收件人聯絡電话',
    address:'*收件人地址',
    freight:'*運費預付/到付',
    retrieve:'是否取回件',
    commodityContent:'*商品内容',
    long:'*長',
    wide:'*寬',
    high:'*高',
    number:'*数量',
    totalWeight: '*總重量',
    collectPayment:'代收貨款',
    remarks:'備註',
  },

  system: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  }
}
